/**
 * Applique une fonction dans le cycle AngularJS si un $scope est disponible,
 * sinon l'exécute directement.
 */
export function applyScope($scope: ng.IScope | undefined, fn: () => void): void {
	if ($scope) ($scope as ng.IScope).$applyAsync(fn);
	else fn();
}
